export default "__VITE_ASSET__CG0xGagG__"